import {TNetworkTrackLabel} from '../types/referential.type'

/**
 * A track option offered by the activity priority cell: the network label's
 * id, name and (optional) acronym. The cell labels each option by
 * `acronym ?? name` and stores the chosen labels as a comma-joined string.
 */
export type PriorityTrackOption = {
  id: string
  name: string
  acronym?: string
}

/**
 * Map live network track labels to priority cell options.
 *
 * Sourced from the track-first referential (`useGetReferentialTracks`), which
 * the backend already filters to `deletedAt: null` — so soft-deleted labels
 * (e.g. the legacy "N/A" track) never appear here. `acronym` is normalised
 * from `null` to `undefined` so the cell falls back to `name`.
 */
export const toPriorityTrackOptions = (
  labels: TNetworkTrackLabel[] | undefined,
): PriorityTrackOption[] =>
  (labels ?? []).map(label => ({
    id: label.id,
    name: label.name,
    acronym: label.acronym ?? undefined,
  }))
